const addToEndOfPlaylist = `data:image/svg+xml;utf8,
<svg viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg" xmlns:bx="https://boxy-svg.com">
  <g transform="matrix(1, 0, 0, 1, 17.860416, -12.87587)">
    <rect x="24.397" width="300" height="44.456" style="stroke-linejoin: round;" rx="15.462" ry="15.462" y="69.126"/>
    <rect x="24.397" width="300" height="44.456" style="stroke-linejoin: round;" rx="15.462" ry="15.462" y="226.133"/>
    <rect x="24.397" width="220" height="44.456" style="stroke-linejoin: round;" rx="15.462" ry="15.462" y="383.14"/>
    <path d="M 528.642 753.983 H 592.019 L 592.019 712.155 L 671.346 772.276 L 592.019 832.398 L 592.019 790.57 H 528.642 V 753.983 Z" style="" transform="matrix(-0.99992, -0.012641, 0.012641, -0.99992, 935.705444, 1182.233032)" bx:shape="arrow 528.642 712.155 142.704 120.243 36.587 79.327 0 1@d424beee"/>
    <rect x="383.704" width="359.307" height="37.651" style="stroke-linejoin: round;" rx="15.462" ry="15.462" y="198.189" transform="matrix(0, 1, -1, 0, 638.071167, -321.404633)"/>
  </g>
</svg>`;

export { addToEndOfPlaylist };
